/* @ngInject */

export default ($q, $window, $filter, logger, WORKFLOW) => {
  /**
   * Retrieve the height for the stages.
   *
   * @param {Object} workflow - Workflow to get stages, job types, messages and documents from.
   * @param {Number} [automationItemHeight] - Height for the single automation tile.
   *
   * @returns {Object} - CSS Object with height in pixels.
   */
  const getStageHeight = (workflow, automationItemHeight) => {
    const windowHeight = angular.element($window).height();
    const aItemHeight = Number.isNaN(parseFloat(automationItemHeight, 10))
      ? WORKFLOW.UI.SINGLE_AUTOMATION_HEIGHT
      : automationItemHeight;
    const largestStage =
      !workflow || !workflow.stages
        ? 0
        : _.maxBy(workflow.stages, function (stage) {
            const j = stage?.jobTypes?.length || 0;
            const m = stage?.idMessages?.length || 0;
            const d = stage?.idDocuments?.length || 0;
            return j + m + d;
          });
    let automationItemsNumber = 0;
    const j = largestStage?.jobTypes?.length || 0;
    const m = largestStage?.idMessages?.length || 0;
    const d = largestStage?.idDocuments?.length || 0;
    automationItemsNumber = j + m + d;
    let automationsOffset = $('automations').position();
    if (parseInt(automationsOffset?.top || 0, 10)) {
      automationsOffset = automationsOffset.top;
    } else {
      automationsOffset = 0;
    }
    const stageMaxHeight = automationItemsNumber * aItemHeight;
    return windowHeight - automationsOffset - WORKFLOW.UI.EDITOR_HEADER_HEIGHT > stageMaxHeight
      ? { height: `${windowHeight - automationsOffset - WORKFLOW.UI.EDITOR_HEADER_HEIGHT}px` }
      : { height: `${stageMaxHeight}px` };
  };

  /**
   * Retrieve team members from accounts.
   *
   * @param {Array} accounts - Accounts.
   * @param {Array} idTeamMembers - Team members IDs.
   *
   * @returns {Array} - Team members.
   */
  const getTeamMembers = (accounts, idTeamMembers) =>
    _.filter(accounts, (account) => idTeamMembers.indexOf(account.id) > -1);

  /**
   * Initialize Workflow Editing.
   *
   * @param {Object} workflow - Workflow.
   * @param {Array} accounts - Accounts.
   *
   * @returns {Object} - Promise.
   */
  const workflowEditInitialize = (workflow, accounts) => {
    const deferred = $q.defer();
    if (!workflow || !workflow.stages || !accounts || !accounts.length) {
      logger.log(
        'workflowEditService',
        'workflowEditInitialize',
        'Waiting for workflows and accounts data'
      );
      deferred.reject();
    } else {
      logger.log(
        'workflowEditService',
        'workflowEditInitialize',
        'Processing accounts for current workflow'
      );
      logger.log(
        'workflowEditService',
        'workflowEditInitialize',
        'Processed accounts for current workflow'
      );
      deferred.resolve();
    }
    return deferred.promise;
  };

  /**
   * Transform accounts array to chips.
   *
   * @param {Array} accounts - Accounts.
   *
   * @returns {Array} - Chips;
   */
  const transformAccountsToChips = (accounts) =>
    _.map(accounts, (account) => ({
      id: account.id,
      name: account.getName(),
      email: account.user.eMail,
      image: account.user.avatar
    }));

  /**
   * Transform team members to chips.
   *
   * @param {Array} idTeamMembers - IDs of team members.
   * @param {Array} accountChips - Account chips.
   *
   * @returns {Array} - Chips;
   */
  const transformTeamMembersToChips = (idTeamMembers, accountChips) =>
    _.filter(accountChips, (chip) => idTeamMembers.indexOf(chip.id) >= 0);

  /**
   * Query chips collection.
   *
   * @param {Object} query - Query.
   * @param {Array} chips - Chips.
   */
  const queryChips = (query, chips) =>
    query
      ? _.filter(chips, (chip) => chip.name.toLowerCase().indexOf(query.toLowerCase()) >= 0)
      : [];

  return {
    getStageHeight,
    getTeamMembers,
    workflowEditInitialize,
    transformAccountsToChips,
    transformTeamMembersToChips,
    queryChips
  };
};
